package ru.villawonka.app.presentation.model

import ru.villawonka.app.domain.model.PostSourceDomain

data class PostSourceUIModel(
    val name: String,
    val imageUrl: String,
    val isTrusted: Boolean,
)

fun PostSourceDomain.toUIModel() = PostSourceUIModel(
    name = name,
    imageUrl = imageUrl,
    isTrusted = isTrusted
)